type AdminQuotaCounterProps = {
  available: number;
  current: number;
};

export const AdminQuotaCounter = ({ available, current }: AdminQuotaCounterProps) => {
  return (
    <div
      className={`admin-detail-quota-counter${current > available ? " is-alert" : ""}`}
      data-alert={current > available ? "true" : "false"}
    >
      {current} / {available}
    </div>
  );
};
